<template>
  <div class="category">
    <a-modal
      v-model:visible="visible"
      :title="`${mode == 'add' ? '新增' : '编辑'}KEY值`"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form
        :rules="rules"
        layout="vertical"
        class="small"
        ref="blockForm"
        :model="formState"
      >
        <a-form-item label="基础语言：" name="name">
          <a-textarea
            v-model:value="formState.defaultValue"
            autosize
            disabled
          />
        </a-form-item>
        <a-form-item label="特定语言文案：" name="name">
          <a-textarea
            v-model:value="formState.itemValue"
            placeholder="请输入语言文案"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { defineExpose, ref, reactive, defineProps, defineEmits } from 'vue'
import useAPI from 'UseApi'
import { Form } from 'ant-design-vue'
const useForm = Form.useForm
const { i18n_value_update_post_ } = useAPI(null, [8997])
const rules = reactive({
  itemValue: [{ required: true, message: '语言文案不能为空' }]
})

let formState = reactive({
  defaultValue: '',
  itemValue: ''
})

const blockForm = ref(null)
const visible = ref(false)
const mode = ref('add')

const { resetFields, validate } = useForm(formState, rules, {})

const open = item => {
  Object.assign(formState, item)
  visible.value = !visible.value
}

const handleOk = async () => {
  await validate()
  await addOrUpdateValue()
  emit('initList')
  visible.value = false
  cancel()
}
const addOrUpdateValue = async () => {
  await i18n_value_update_post_({
    ...formState,
    items: [
      {
        languageCode: props.languageCode,
        itemValue: formState.itemValue
      }
    ],
    siteCode: props.siteCode
  })
}

const cancel = () => {
  resetFields()
}
const props = defineProps({
  languageCode: String,
  siteCode: String
})
const emit = defineEmits(['initList'])
defineExpose({ open })
</script>
